var map = {
	"./01_open_mushaf.svg": 1136,
	"./02_closed_quran_bookmark.svg": 56241,
	"./03_new_lesson_jadid.svg": 25023,
	"./04_review_yesterday_madi.svg": 79463,
	"./05_old_revision_sard.svg": 93519,
	"./06_hizb_marker.svg": 13176,
	"./07_juz_divider.svg": 20374,
	"./08_khatma_seal.svg": 78540,
	"./09_student.svg": 99536,
	"./10_teacher_sheikh.svg": 52386,
	"./11_family_parent.svg": 10293,
	"./12_director_moudir.svg": 5964,
	"./13_halaqa_circle.svg": 75429,
	"./14_profile_avatar.svg": 35768,
	"./15_hafiz_laurel.svg": 77830,
	"./16_class_roster.svg": 33985,
	"./17_star_rating.svg": 20356,
	"./18_trophy.svg": 76779,
	"./19_diploma_scroll.svg": 88416,
	"./20_medal.svg": 85947,
	"./21_crescent_badge.svg": 44404,
	"./22_laurel_wreath.svg": 85563,
	"./23_award_ribbon.svg": 45169,
	"./24_excellence_seal.svg": 42268,
	"./25_attendance_check.svg": 67917,
	"./26_calendar.svg": 1642,
	"./27_calendar_present.svg": 15117,
	"./28_calendar_absent.svg": 9468,
	"./29_bar_chart.svg": 39477,
	"./30_trend_chart.svg": 3185,
	"./31_donut_chart.svg": 71209,
	"./32_gauge.svg": 60190,
	"./33_clock.svg": 15476,
	"./34_hourglass.svg": 60091,
	"./35_month_calendar.svg": 12883,
	"./36_streak_flame.svg": 18263,
	"./37_mosque_small.svg": 30128,
	"./38_sunrise_fajr.svg": 7896,
	"./39_bell.svg": 22911,
	"./40_alarm.svg": 79343,
	"./41_microphone.svg": 24007,
	"./42_waveform.svg": 55775,
	"./43_lips_pronounce.svg": 85879,
	"./44_tajweed_letter.svg": 42665,
	"./45_headphones.svg": 99538,
	"./46_play.svg": 62372,
	"./47_repeat_loop.svg": 91853,
	"./48_big_check.svg": 28783,
	"./49_home_dashboard.svg": 45331,
	"./50_settings_gear.svg": 42292,
	"./51_search.svg": 8190,
	"./52_bell_filled.svg": 44131,
	"./53_logout_door.svg": 21517,
	"./54_add_plus.svg": 88721,
	"./55_edit_pencil.svg": 54962,
	"./56_filter.svg": 61841,
	"./57_mosque_detailed.svg": 12409,
	"./58_crescent_star.svg": 95079,
	"./59_lantern_fanous.svg": 83971,
	"./60_prayer_beads.svg": 81009,
	"./61_geo_star.svg": 56835,
	"./62_mihrab_arch.svg": 60296,
	"./63_date_palm.svg": 20538,
	"./64_rihal_stand.svg": 44309,
	"./65_new_wird_jadid.svg": 18865,
	"./66_yesterday_madi.svg": 7660,
	"./67_old_sard.svg": 73647
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81569;